var _path, _line, _line2, _path2, _path3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2h12v8a6 6 0 0 1-12 0V2z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 20
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 16,
    y2: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H4a2 2 0 0 0 0 4h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4h2a2 2 0 0 1 0 4h-2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12,5 12.8,7 15,7 13.2,8.4 14,10.5 12,9 10,10.5 10.8,8.4 9,7 11.2,7",
    fill: "#2399E3",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.1ae7bef0e42792426e27e2a9b96ec93c.svg";
export { ForwardRef as ReactComponent };